import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'interestTierrateFormat',
})
export class InterestTierrateFormatFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    const str = String(value);
    return str.endsWith('.00') ? str.split('.')[0] : str;
  }
}
